<template>
  <div id="evaluator-info">
    <mainHeader class="mainHeader" @logout="logoutClick"></mainHeader>
    <div class="wrapper">
      <div class="section section1">
        <div class="title">风险评测</div>
      </div>
      <div class="section section2">
        <div class="image"></div>
      </div>
      <div class="section section3">
        <div class="title">消防安全责任人/管理人信息</div>
        <div class="box">
          <div class="tip">评测人姓名</div>
          <input type="text" v-model="userName" :disabled="binName" placeholder="请输入评测人姓名" v-on:blur="blur()" v-on:focus="focus()"/>
        </div>
        <div class="box">
          <div class="tip">评测人身份证号</div>
          <input type="text" v-model="userIDCard" :disabled="bindCard" placeholder="请输入评测人身份证号"  v-on:blur="blur()" v-on:focus="focus()" />
        </div>
      </div>
    </div>
    <bottomButton v-show="showBottom" id="bottomButton" title="开始评测" :state="bottomState"  @click="bottomClick"></bottomButton>

  </div>

</template>

<script>
import mainHeader from '../view/header'
import bottomButton from '../components/bottom-button'
import { Toast } from 'mint-ui'
import wxShare from '../wx/weixin.js'
export default {
  data () {
    return {
      // 原始高度
      documentHeight: document.documentElement.clientHeight,
      // 实时屏幕高度
      showHeight: document.documentElement.clientHeight,
      // 是否显示底部按钮
      showBottom: true,
      progressViewVisible: false,
      userName: '',
      userIDCard: '',
      binName: false,
      bindCard: false,
      ableBottom: 1
    }
  },
  methods: {
    logoutClick: function () { // 退出登录
      this.$router.push({path: 'home'})
    },
    onResizeHeight: function () { // input  android 监听屏幕高度变化
      // Toast('showHeight----' + this.showHeight)
      // Toast('documentHeight----' + document.body.clientHeight)
      // var _this = this
      // window.onresize = function () {
      //   _this.showHeight = document.body.clientHeight
      //   Toast('showHeight----' + document.body.clientHeight)
      // }
      // window.onresize = () => {
      //   return (() => {
      //     _this.showHeight = document.body.clientHeight
      //   })()
      // }
    },
    focus: function () {
      if (!this.utils.isIphone()) {
        document.getElementById('bottomButton').style.display = 'none'
      }
    },
    blur: function () {
      if (this.utils.isIphone()) { // iphone 适配键盘 弹出 回弹
        const currentScrollY = window.scrollY
        window.scrollTo(0, currentScrollY)
      } else {
        document.getElementById('bottomButton').style.display = 'block'
      }
    },
    bottomClick: function () { // 开始评测 提交企业信息
      // 统计
      this.utils.listenEvent(12, '', window.location.href, '')
      var _this = this
      if (this.checkCompanyInfo() === true) {
        // 按钮 不可多次单击
        if (this.ableBottom === 0) return
        this.ableBottom = 0
        var param = this.QS.parse(this.$route.query.companyInfo)
        param.real_name = this.userName
        param.real_idcard = this.userIDCard
        console.log(param)
        this.utils.POSTQS(this.accountUrl + '/riskeval/saveUserData', false, param, function (response) {
          if (parseInt(response.code) === 0) {
            _this.ableBottom = 0
            console.log('去评测========================')
            _this.$router.push({path: 'evaluate-category2'})
          } else {
            _this.ableBottom = 1
          }
        })
      }
    },
    checkCompanyInfo: function () {
      if (this.utils.isNull(this.userName)) {
        Toast('请输入评测人姓名')
        return false
      }
      if (this.utils.isNull(this.userIDCard)) {
        Toast('请输入评测人身份证号')
        return false
      }
      return true
    },
    loadData: function () {
      let companyInfo = this.QS.parse(this.$route.query.companyInfo)
      console.log(companyInfo)
      this.userName = companyInfo.real_name
      this.userIDCard = companyInfo.real_idcard
      if (!this.utils.isNull(companyInfo.real_name)) {
        this.binName = true
      }
      if (!this.utils.isNull(companyInfo.real_idcard)) {
        this.bindCard = true
      }
    },
    binBack: function () {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', function () {
        history.pushState(null, null, document.URL)
      })
    }
  },
  watch: {
    $router () {
    },
    showHeight () {
      // Toast('监听===' + this.documentHeight + '--' + this.showHeight)
      // if (this.documentHeight > this.showHeight) {
      //   this.showBottom = false
      // } else {
      //   this.showBottom = true
      // }
      // Toast('监听11===' + this.documentHeight + '--' + this.showHeight)
    }
  },
  computed: {
    bottomState: function () { // 底部按钮状态
      if (!this.utils.isNull(this.userName) && !this.utils.isNull(this.userIDCard)) {
        return 1
      }
      return 0
    }
  },
  components: {
    mainHeader,
    bottomButton
  },
  mounted () {
    var _this = this
    this.utils.isUserLogin(function (login) {
      console.log('==========' + login)
      if (login === 0) {
        Toast('您还未登录，请登录后再评测！')
        _this.$router.push({path: 'home'})
      }
    })

    this.loadData()
    this.onResizeHeight()
    this.binBack()
    // 微信 分享
    let imgUrl = 'http://cdn.zxzx119.com/39073939414056960'
    wxShare.wxRegister('消防安全风险评测', '中消在线风险评测  一站式解决企业风险隐患', imgUrl)
    // 统计
    this.utils.listenEvent(11, '', window.location.href, '')
  }
}
</script>

<style scoped>
  .mainHeader{
    position: fixed;
    top: 0px;
    height: 55px;
    width: 100%;
    z-index: 500;
  }
  .wrapper {
    background-color: #f4f4f4;
    height: 100%;
    margin-top: 55px;
    /*padding-bottom: 65px;*/
  }
  .section{
    position: relative;
    width: 100%;
    margin-bottom: 10px;
    background-color: #FFFFFF;
  }
  .section3{
    margin-bottom: 1px;
  }
  .section .title{
    height: 50px;
    line-height: 50px;
    color: #000;
    font-size: 16px;
    font-weight: bold;
    margin-left: 15px;
  }
  .section3 .title{
    width: 200px;
    border-bottom: solid 3px #C41335;
    box-sizing: border-box;
  }
  .section1{
    height: 50px;
  }
  .section2{
    height: 70px;
  }
  .section2 .image{
    width: 100%;
    height: 70px;
    background-image: url("../assets/icon_evaluate.jpg");
    background-size: cover;
    background-position: center center;
  }
  .section4{
    height: 140px;
  }
  .section .box{
    position: relative;
    width: 100%;
    height: 45px;
    border-top: solid 1px #EEEEEE;
    box-sizing: border-box;
    font-size: 14px;
    color: #000;
  }
  .section .box .tip{
    position: absolute;
    left: 15px;
    height: 45px;
    line-height: 45px;
  }
  .section .box input{
    position: absolute;
    top: 7px;
    /*height: 44px;*/
    height: 30px;
    line-height: 30px;
    left: 120px;
    right: 15px;
    border: none;
    box-sizing: border-box;
    /*background-color: #FFEECC;*/
  }
  /*.section .box .code{*/
  /*  right: 110px;*/
  /*}*/
  .section .box .codebtn{
    position: absolute;
    right: 0px;
    width: 100px;
    height: 44px;
    line-height: 44px;
    color: #C41335;
    text-align: center;

    border-left: solid 1px #EEEEEE;
    box-sizing: border-box;
    /*background-color: rebeccapurple;*/
  }

  .address-popup{
    width: 100%;
    height: 210px;
  }
  .progress-popup{
    position: center;
    width: 90%;
    height: 200px;
    border-radius: 3px;
    overflow: hidden;
  }
  .progress-popup .header{
    width: 100%;
    padding-left: 20px;
    height: 45px;
    line-height: 45px;
    background-color: #c41335;
    color: #FFFFFF;
    font-size: 16px;
    font-weight: bold;
  }
  .progress-popup .tip{
    width: 100%;
    margin-top: 15px;
    height: 45px;
    line-height: 45px;
    color: #323232;
    font-size: 16px;
    text-align: center;
  }
  .progress-popup .progressbtn{
    position: center;
    width: 130px;
    margin: 20px auto auto auto;
    height: 40px;
    line-height: 40px;
    background-color: #c41335;
    color: #ffffff;
    font-size: 15px;
    text-align: center;
    border-radius: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/view/evaluator-info.vue